




























import { Component, Prop, Vue } from 'vue-property-decorator';
import { RegionState, Region, DataRegion } from '@/store/region/types';
import { State, Action, Getter, Mutation, namespace } from 'vuex-class';
import {
  AdminSiteState,
  AdminSite,
  DataAdminSite,
} from '@/store/adminsite/types';
import { SmartState, Smart, DataDevice } from '@/store/smart/types';
import { IMessage } from '@/store/alert/types';
import Alert from '@/components/Alert.vue';
import Table from '@/components/Table.vue';
import Cards from '@/components/Cards.vue';
import { adminsite } from '../../store/adminsite';

@Component({
  components: {
    Alert,
    Table,
    Cards,
  },
})
export default class ManagementSite extends Vue {
  @Mutation('alert/SHOW') private alert: (alertMessage: IMessage) => void;
  @Mutation('ADMINSITE_PUT', { namespace: 'adminsite' })
  private adminSitePut: any;
  @Mutation('ADMINSITE_DEVICE_CREATE', { namespace: 'adminsite' })
  private adminSiteCreate: any;
  @Mutation('ADMINSITE_DEVICE_DELETE', { namespace: 'adminsite' })
  private adminSiteDelete: any;
  @Action('get', { namespace: 'adminsite' }) private get: () => void;
  @Action('get', { namespace: 'smart' }) private getSmart: () => void;
  @Action('add', { namespace: 'adminsite' }) private add: (
    adminsite: AdminSite,
  ) => Promise<undefined>;
  @Action('put', { namespace: 'adminsite' }) private put: (
    adminsite: AdminSite,
  ) => Promise<undefined>;
  @Action('delete', { namespace: 'adminsite' }) private delete: (
    _id: string,
  ) => Promise<undefined>;
  @State('region') private regionState: RegionState;
  @State('adminsite') private adminSiteState: AdminSiteState;
  @State('smart') private smartState?: SmartState;
  @Prop(String) private search?: string;

  inputName: string = '';
  canOtherPut: Boolean = true;

  get filter() {
    let dataAdminSites: DataAdminSite[];
    let dataDevices: DataDevice[];
    dataAdminSites = this.adminSiteState.dataAdminSite
      ? this.adminSiteState.dataAdminSite
      : [];
    dataDevices = this.smartState!.dataDevices
      ? this.smartState!.dataDevices
      : [];

    let filteredArray = dataDevices!.filter((device) => {
      let found = false;
      if (dataAdminSites)
        dataAdminSites!.forEach((dataAdminSite) => {
          if (dataAdminSite.devices)
            dataAdminSite.devices!.forEach((d) => {
              found = found || device._id === d._id;
            });
        });
      return !found;
    });
    return filteredArray;
  }

  created() {
    this.adminSiteState.dataAdminSite = [];
  }

  mounted() {
    this.getSmart();
    this.get();
  }

  public input(e: any) {
    this.inputName = e.target.value;
  }

  public putEvent() {
    this.canOtherPut = false;
  }

  public onCancel() {
    this.canOtherPut = true;
    this.get();
    this.getSmart();
  }

  public activeCreate() {
    if (this.canOtherPut === true) {
      this.canOtherPut = false;
      this.adminSiteCreate();
    }
  }

  public onCreate(adminSite: AdminSite) {
    let name: string;
    let arrayDevices: Smart[] = [];
    for (let i = 0; i < adminSite.devices.length; i++) {
      arrayDevices.push(adminSite.devices[i]);
    }
    name = adminSite.name! !== '' ? adminSite.name! : '';
    let singleAdminSite = {
      name: name,
      devices: arrayDevices,
    };
    if (singleAdminSite && singleAdminSite.name !== undefined) {
      this.add(singleAdminSite)
        .then(() => {
          this.canOtherPut = true;
          this.get();
          this.getSmart();
        })
        .catch(() => {});
    } else {
      this.alert({
        prefix: 'INPUT_',
        error: 'EMPTY',
      });
    }
  }

  public onPut(arg: DataAdminSite) {
    let name: string = '';
    let arrayDevices: Smart[] = [];
    for (let i = 0; i < arg.devices.length; i++) {
      arrayDevices.push(arg.devices[i]);
    }
    name = arg.name! !== '' ? arg.name! : '';
    let singleAdminSite = {
      _id: arg._id,
      name: name,
      devices: arg.devices,
    };
    this.put(singleAdminSite)
      .then(() => {
        this.canOtherPut = true;
        this.get();
        this.getSmart();
      })
      .catch(() => {});
  }

  public onDelete(arg: DataAdminSite) {
    let Conf = confirm('Voulez-vous supprimer votre site ?');
    if (Conf === true) {
      this.delete(arg._id)
        .then(() => {
          this.get();
          this.getSmart();
        })
        .catch(() => {});
    }
  }

  public addBox(arg: DataAdminSite) {
    this.adminSitePut(arg);
  }

  public deleteBox(arg: DataDevice) {
    this.adminSiteDelete(arg);
  }
}
